"use client";

import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { useLocale, useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import type { Locale } from "@/i18n/config";
import { buildContentUrl } from "@/lib/routing/url-builder";
import { ArticlesSection } from "@/components/sections/articles-section";
import { TextButton } from "@repo/ui/text-button";
import { toArticleCardFields } from "@/lib/articles/article-card";
import type { QueryArticlePageDataResult } from "@/lib/sanity/sanity.types";
type RelatedArticle = NonNullable<NonNullable<QueryArticlePageDataResult>["relatedArticles"]>[number];
interface RelatedArticlesSectionProps {
  articles: RelatedArticle[] | null | undefined;
}
export function RelatedArticlesSection(t0) {
  const $ = _c(24);
  const {
    articles
  } = t0;
  const locale = useLocale() as Locale;
  const t = useTranslations("common");
  if (!articles || articles.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== locale) {
    t1 = buildContentUrl("/articles", locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const articlesUrl = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("otherArticles");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h2 className="typography-mobile-heading-h5 desktop:typography-desktop-heading-h5 text-text-primary">{t2}</h2>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = articlesUrl as never;
  let t5;
  if ($[6] !== t) {
    t5 = t("viewAllNews");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <TextButton asChild={true} iconRight={null} size="md" className="border-open-water-500 py-1 desktop:typography-component-md-medium"><Link href={t4}>{t5}</Link></TextButton>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <div className="container-grid"><div className="col-span-full flex items-end justify-between gap-12">{t3}{t6}</div></div>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== articles || $[15] !== locale) {
    let t9;
    if ($[17] !== locale) {
      t9 = article => ({
        id: article._id,
        ...toArticleCardFields(article, locale)
      });
      $[17] = locale;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    t8 = articles.map(t9);
    $[14] = articles;
    $[15] = locale;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <div className="mt-10"><ArticlesSection articles={t8} /></div>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t9) {
    t10 = <section data-testid="related-articles-section" className="py-20 desktop:py-48">{t7}{t9}</section>;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}